module.exports = __webpack_public_path__ + "static/media/sleeping.a9800a9d.svg";